import { environment } from '../environments/environment';

export const APP_API = environment.api;
export const APP_API_CONVITE = environment.api_convites;
export const REDIRECIONAMENTO_EXTERNO = environment.redirecionamento_externo;
export const APP_CONVITES = environment.convites;
